export default __webpack_public_path__ + "9a66ae0684c7a0cc0490e68cebd05f3b.svg";